import React from 'react'
import { CustomInput } from 'src/consumer/components/helperComponents'

export default function RestCreationComponent({ formData, setFormData, handleChangeFeature }) {
  return <></>
}
